import React, { useState, useContext, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Accordion } from "react-bootstrap";
import Swal from "sweetalert2";
import { CartContext } from "../context/CartContext";

const CargarVenta = ({ productData, show, handleClose }) => {
  const { loadProducts } = useContext(CartContext);
  const [loading, setLoading] = useState(false);
  const [etiquetaFile, setEtiquetaFile] = useState(null);

  const [formData, setFormData] = useState({
    nombre_cliente: "",
    dni: "",
    producto: "",
    marco: "",
    precio: "",
    metodo_pago: "Transferencia",
    nro_operacion: "",
    tarjeta: "",

    od_e: "",
    od_c: "",
    od_a: "",

    oi_e: "",
    oi_c: "",
    oi_a: "",

    add: "",

    od_dnp: "",
    od_alt: "",

    oi_dnp: "",
    oi_alt: "",

    observaciones: "",
  });

  // --- FUNCIONES DE FORMATO PARA WHATSAPP ---

  // Si no hay valor, devuelve vacío. Si hay, pone el signo (+/-) y la etiqueta (e, c, ADD)
  const formatGrad = (val, label) => {
    if (val === "" || val === null || val === undefined) return "";
    const num = parseFloat(val);
    if (isNaN(num)) return "";
    const signo = num > 0 ? "+" : "";
    return ` ${label}: ${signo}${num.toFixed(2)}`;
  };

  // Formatea el eje solo si tiene datos
  const formatEje = (val) => {
    return val !== "" && val !== null && val !== undefined ? ` a: ${val}` : "";
  };

  useEffect(() => {
    if (productData) {
      setFormData((prev) => ({ ...prev, marco: productData.titulo }));
    }
  }, [productData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setEtiquetaFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const dataToSend = new FormData();

    dataToSend.append("auth_token", "OM_VENTAS_2024_SECURE");

    dataToSend.append("id_producto", productData.id);

    Object.keys(formData).forEach((key) => {
      dataToSend.append(key, formData[key] ?? "");
    });

    if (etiquetaFile) dataToSend.append("etiqueta_pdf", etiquetaFile);

    try {
      const resp = await fetch(
        "https://optimarketok.com.ar/api/process_sale.php",
        {
          method: "POST",
          body: dataToSend,
          credentials: "include",
        },
      );

      const res = await resp.json();

      if (res.success) {
        const urlDetalleProducto = `https://optimarketok.com.ar/detalle/${productData.id}/`;

        // --- CONSTRUCCIÓN DEL MENSAJE LIMPIO ---

        // Ojo Derecho
        const od_e = formatGrad(formData.od_e, "e");
        const od_c = formatGrad(formData.od_c, "c");
        const od_a = formatEje(formData.od_a);
        const od_final =
          od_e || od_c || od_a ? `${od_e}${od_c}${od_a}` : " Plano";

        // Ojo Izquierdo
        const oi_e = formatGrad(formData.oi_e, "e");
        const oi_c = formatGrad(formData.oi_c, "c");
        const oi_a = formatEje(formData.oi_a);
        const oi_final =
          oi_e || oi_c || oi_a ? `${oi_e}${oi_c}${oi_a}` : " Plano";

        // Adición
        const add_val = formatGrad(formData.add, "ADD");

        const textoParaCopiar = `✅ *Nueva Venta*

🖼️ *Producto:* ${urlDetalleProducto}

👤 *Cliente:* ${formData.nombre_cliente.toUpperCase()}
👓 *Cristal:* ${formData.producto}

👁️ *OD:*${od_final}
👁️ *OI:*${oi_final}
${add_val ? "➕" + add_val + "\n" : ""}
🗓️ *Entrega:* ${res.fecha_entrega}
📄 *Ficha PDF:* ${res.pdf_url}`;

        Swal.fire({
          title: "¡Venta Registrada!",
          text: "Datos guardados. ¿Copiar para WhatsApp?",
          icon: "success",
          showCancelButton: true,
          confirmButtonColor: "#25D366",
          confirmButtonText: "📋 Copiar Texto",
          cancelButtonText: "Cerrar",
        }).then((result) => {
          if (result.isConfirmed) {
            navigator.clipboard.writeText(textoParaCopiar).then(() => {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "¡Copiado al portapapeles!",
                showConfirmButton: false,
                timer: 1500,
              });
            });
          }
        });

        await loadProducts();
        handleClose();
      } else {
        Swal.fire(
          "Error",
          res.message || "No se pudo procesar la venta",
          "error",
        );
      }
    } catch (err) {
      Swal.fire("Error", "Error de conexión con el servidor", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title>Registrar Venta de Anteojo</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <h6 className="text-muted text-uppercase fw-bold border-bottom pb-2">
            1. Detalle del Trabajo
          </h6>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label className="fw-bold text-dark">
                Armazón (Marco)
              </Form.Label>
              <Form.Control
                name="marco"
                value={formData.marco}
                readOnly
                className="bg-light"
              />
            </Col>
            <Col md={6}>
              <Form.Label className="fw-bold text-primary">
                Cargar Etiqueta Correo (PDF)
              </Form.Label>
              <Form.Control
                type="file"
                accept=".pdf"
                onChange={handleFileChange}
              />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col md={6}>
              <Form.Label>Apellido y nombre</Form.Label>
              <Form.Control
                name="nombre_cliente"
                required
                onChange={handleChange}
                placeholder="Ej: Juan Perez"
              />
            </Col>
            <Col md={6}>
              <Form.Label className="fw-bold text-primary">
                Tipo de Cristales
              </Form.Label>
              <Form.Control
                name="producto"
                required
                onChange={handleChange}
                placeholder="Ej: Orgánico Blue Light"
              />
            </Col>
          </Row>

          <h6 className="text-muted text-uppercase fw-bold border-bottom pb-2 mb-3">
            2. Receta Óptica
          </h6>
          <Row className="text-center fw-bold mb-2 d-none d-md-flex">
            <Col md={2}></Col>
            <Col md={3}>Esfera</Col>
            <Col md={3}>Cilindro</Col>
            <Col md={2}>Eje°</Col>
            <Col md={2}>Add</Col>
          </Row>

          {/* Ojo Derecho */}
          <Row className="mb-2 align-items-center">
            <Col md={2} className="fw-bold text-end text-primary">
              OD:
            </Col>
            <Col md={3}>
              <Form.Control
                type="number"
                step="0.25"
                name="od_e"
                placeholder="0.00"
                onChange={handleChange}
              />
            </Col>
            <Col md={3}>
              <Form.Control
                type="number"
                step="0.25"
                name="od_c"
                placeholder="0.00"
                onChange={handleChange}
              />
            </Col>
            <Col md={2}>
              <Form.Control
                type="number"
                name="od_a"
                placeholder="Eje"
                onChange={handleChange}
              />
            </Col>
          </Row>

          {/* Ojo Izquierdo */}
          <Row className="mb-4 align-items-center">
            <Col md={2} className="fw-bold text-end text-primary">
              OI:
            </Col>
            <Col md={3}>
              <Form.Control
                type="number"
                step="0.25"
                name="oi_e"
                placeholder="0.00"
                onChange={handleChange}
              />
            </Col>
            <Col md={3}>
              <Form.Control
                type="number"
                step="0.25"
                name="oi_c"
                placeholder="0.00"
                onChange={handleChange}
              />
            </Col>
            <Col md={2}>
              <Form.Control
                type="number"
                name="oi_a"
                placeholder="Eje"
                onChange={handleChange}
              />
            </Col>
            <Col md={2}>
              <Form.Control
                type="number"
                step="0.25"
                name="add"
                placeholder="Add"
                onChange={handleChange}
              />
            </Col>
          </Row>
          <Accordion className="mb-4">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                Datos adicionales (DNP / ALT / Observaciones)
              </Accordion.Header>

              <Accordion.Body>
                <Row className="mb-3">
                  <Col md={3}>
                    <Form.Label>OD DNP</Form.Label>
                    <Form.Control
                      type="number"
                      name="od_dnp"
                      placeholder="OD DNP"
                      onChange={handleChange}
                    />
                  </Col>

                  <Col md={3}>
                    <Form.Label>OD ALT</Form.Label>
                    <Form.Control
                      type="number"
                      name="od_alt"
                      placeholder="OD ALT"
                      onChange={handleChange}
                    />
                  </Col>

                  <Col md={3}>
                    <Form.Label>OI DNP</Form.Label>
                    <Form.Control
                      type="number"
                      name="oi_dnp"
                      placeholder="OI DNP"
                      onChange={handleChange}
                    />
                  </Col>

                  <Col md={3}>
                    <Form.Label>OI ALT</Form.Label>
                    <Form.Control
                      type="number"
                      name="oi_alt"
                      placeholder="OI ALT"
                      onChange={handleChange}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <Form.Label>Observaciones</Form.Label>

                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="observaciones"
                      placeholder="Ej: Blue cut, urgente, cliente trae marco, etc."
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <h6 className="text-muted text-uppercase fw-bold border-bottom pb-2 mb-3">
            4. Datos de Pago
          </h6>
          <Row className="align-items-end">
            <Col md={3}>
              <Form.Label className="fw-bold text-success fs-5">
                PRECIO TOTAL ($)
              </Form.Label>
              <Form.Control
                name="precio"
                type="number"
                required
                onChange={handleChange}
                className="form-control-lg border-success fw-bold text-success"
                placeholder="0.00"
              />
            </Col>
            <Col md={3}>
              <Form.Label>Método de Pago</Form.Label>
              <Form.Select name="metodo_pago" onChange={handleChange}>
                <option value="Transferencia">Transferencia</option>
                <option value="Un pago">Un pago</option>
                <option value="3 cuotas">3 cuotas</option>
                <option value="6 cuotas">6 cuotas</option>
              </Form.Select>
            </Col>
            <Col md={2}>
              <Form.Label>DNI</Form.Label>
              <Form.Control
                name="dni"
                onChange={handleChange}
                placeholder="DNI"
              />
            </Col>
            <Col md={2}>
              <Form.Label>Entidad</Form.Label>
              <Form.Control
                name="tarjeta"
                placeholder="Visa/Master"
                onChange={handleChange}
              />
            </Col>
            <Col md={2}>
              <Form.Label>Nro Op</Form.Label>
              <Form.Control
                name="nro_operacion"
                onChange={handleChange}
                placeholder="0000"
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="bg-light">
          <Button variant="outline-secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            variant="success"
            type="submit"
            disabled={loading}
            className="px-5 fw-bold"
          >
            {loading ? "PROCESANDO..." : "REGISTRAR VENTA Y STOCK"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CargarVenta;
